import { GET_DEVICE, RESET_DEVICE_ERROR } from '../actions'

const INITIAL_STATE = {}

function DevicesReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case GET_DEVICE:
            return {
                ...state,
                [action.payload.body ? action.payload.body.uuid : 'error']: action.payload.body || action.payload,
            }
        case RESET_DEVICE_ERROR:
            return {
                ...state,
                error: null,
            }
        default: return state
    }
}

export default DevicesReducer



// WEBPACK FOOTER //
// ./src/reducers/devices.js